var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons64/System - Chatbot"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 11.8913C23.625 5.53 18.4208 0.375 12.001 0.375C5.57989 0.375 0.375 5.53 0.375 11.8913C0.375 18.2512 5.57989 23.4076 12.001 23.4076C14.0449 23.4076 15.9663 22.8815 17.6366 21.9635L23.4613 23.625L21.9967 17.7708C23.0299 16.0499 23.625 14.0401 23.625 11.8913ZM8.36539 12.1875C8.36539 13.3266 7.41614 14.25 6.24519 14.25C5.07424 14.25 4.125 13.3266 4.125 12.1875C4.125 11.0484 5.07424 10.125 6.24519 10.125C7.41614 10.125 8.36539 11.0484 8.36539 12.1875ZM12 14.25C13.1709 14.25 14.1202 13.3266 14.1202 12.1875C14.1202 11.0484 13.1709 10.125 12 10.125C10.8291 10.125 9.87981 11.0484 9.87981 12.1875C9.87981 13.3266 10.8291 14.25 12 14.25ZM17.7548 14.25C18.9258 14.25 19.875 13.3266 19.875 12.1875C19.875 11.0484 18.9258 10.125 17.7548 10.125C16.5839 10.125 15.6346 11.0484 15.6346 12.1875C15.6346 13.3266 16.5839 14.25 17.7548 14.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_438_3348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 10,
    width: 16,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Color_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24519 14.25C7.41614 14.25 8.36539 13.3266 8.36539 12.1875C8.36539 11.0484 7.41614 10.125 6.24519 10.125C5.07424 10.125 4.125 11.0484 4.125 12.1875C4.125 13.3266 5.07424 14.25 6.24519 14.25ZM14.1202 12.1875C14.1202 13.3266 13.1709 14.25 12 14.25C10.829 14.25 9.8798 13.3266 9.8798 12.1875C9.8798 11.0484 10.829 10.125 12 10.125C13.1709 10.125 14.1202 11.0484 14.1202 12.1875ZM19.875 12.1875C19.875 13.3266 18.9258 14.25 17.7548 14.25C16.5839 14.25 15.6346 13.3266 15.6346 12.1875C15.6346 11.0484 16.5839 10.125 17.7548 10.125C18.9258 10.125 19.875 11.0484 19.875 12.1875Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_438_3348)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.ddcfcb40cb33b2e05c292cbceb5229e9.svg";
export { ForwardRef as ReactComponent };